import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioComponent } from '../radio/radio.component';

@Component({
  selector: 'hdi-radio-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio-group.component.html',
  styleUrl: './radio-group.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class RadioGroupComponent implements AfterContentInit {
  @Input() multiSelectable: boolean = false;

  @Input() disabled: boolean = false;
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  @ContentChildren(RadioComponent) radios: QueryList<RadioComponent> =
    new QueryList<RadioComponent>();
  @Output() valueChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  ngAfterContentInit(): void {
    this.setupRadioButtons();
  }

  setupRadioButtons(): void {
    if (this.radios) {
      if (this.multiSelectable) {
        this.radios.forEach((radio) => {
          radio.disabled = this.disabled;
          radio.changes.subscribe(() => {
            this.valueChange.emit(this.getSelectedValues());
          });
        });
      } else {
        // allow only one radio to be selected
        this.radios.forEach((radio) => {
          radio.disabled = this.disabled;
          radio.changes.subscribe((value: string) => {
            this.radios.forEach((r) => {
              r.checked = r.value === value;
            });
            this.valueChange.emit([value]);
          });
        });
      }
    }
  }

  getSelectedValues(): string[] {
    return this.radios
      .filter((radio) => radio.checked)
      .map((radio) => radio.value);
  }
}
